"use client";
import React from "react";
import Link from "next/link";
import { motion } from "framer-motion";

const categories = [
  { name: "Data Science", slug: "data-science" },
  { name: "Web Development", slug: "web-development" },
  { name: "Digital Marketing", slug: "digital-marketing" },
  { name: "Content Writing", slug: "content-writing" },
  { name: "AI & ML", slug: "ai-ml" },
  { name: "QA & Testing", slug: "qa-testing" },
  { name: "Data Engineering", slug: "data-engineering" },
];

const HeroSection = ({ herotext }) => {
  return (
    <section className="relative w-full min-h-[500px] flex flex-col justify-center items-center overflow-hidden bg-[#020617]">
      {/* 2026 Ambient Background */}
      <div className="absolute inset-0 opacity-40">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-blue-600 blur-[120px] rounded-full" />
        <div className="absolute bottom-[-10%] right-[-10%] w-[30%] h-[30%] bg-cyan-500 blur-[120px] rounded-full" />
      </div>

      <div className="container relative z-10 px-6 mx-auto text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <span className="inline-block px-4 py-1.5 mb-6 text-xs font-bold tracking-widest text-blue-400 uppercase bg-blue-500/10 border border-blue-500/20 rounded-full">
            Knowledge Hub
          </span>
          <h1 className="max-w-4xl mx-auto text-4xl font-extrabold tracking-tight text-white md:text-6xl lg:text-7xl leading-[1.1]">
            {herotext} <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-cyan-300">Hub.</span>
          </h1>
        </motion.div>

        {/* Floating Category Dock */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
          className="flex flex-wrap justify-center gap-3 mt-12 max-w-5xl mx-auto"
        >
          <Link href="/blog/">
            <button className="px-6 py-2.5 text-sm font-semibold text-white bg-blue-600 rounded-full hover:bg-blue-500 transition-all shadow-[0_0_20px_rgba(37,99,235,0.4)]">
              All Posts
            </button>
          </Link>

          {categories.map((cat) => (
            <Link key={cat.slug} href={`/blog/${cat.slug}`}>
              <button className="px-5 py-2.5 text-sm font-medium text-slate-300 bg-white/5 border border-white/10 backdrop-blur-md rounded-full hover:bg-white/10 hover:text-white transition-all">
                {cat.name}
              </button>
            </Link>
          ))}
        </motion.div>
      </div>

      {/* Modern Grid Overlay */}
      <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-20 pointer-events-none"></div>
    </section>
  );
};

export default HeroSection;